import * as React from 'react'
import Accordion, { Item } from '../../Shared/Accordion'
import { contains } from 'ramda'
import { connect, Dispatch } from 'react-redux'

import {
  selectCaseItem,
  selectFirstBeam,
  selectFirstSlab,
  selectFirstLoadCase
} from '../../../actions/project'
import { ItemLine } from './InputCategoryStyles'
import { Store } from '../../../reducers'
import {
  getActiveCase,
  EditableCase,
  getValidCategories,
  getActiveCategory,
  getSelectedItemId,
  getTouchedCategories,
  getActiveInputSet,
  getDrTypeBeam,
  getProjectLocation
} from '../../../reducers/project'
import { updateOpenInputSets } from '../../../actions/calculation'
import InputLoads from './InputLoads'

import { showSpaceType } from '../../../location_changes/conversionHelper'

type Props = {
  case: EditableCase | undefined
  isDrBeam: boolean

  location: string

  validCategories: string[]
  openInputSets: number[]

  activeCategory: string | undefined
  activeItem: string | null
  touchedCategories: string[]

  /* tslint:disable no-any */
  updateInputSets: (items: number[]) => any
  selectItem: (itemId: string) => any
  selectFirstBeam: () => any
  selectFirstSlab: () => any
  selectFirstLoadCase: () => any
  /* tslint:enable no-any */
}

type State = {
  openSubItems: number[]
  open: boolean
}

export class InputCase extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      open: true,
      openSubItems: [0, 1]
    }
  }

  treeChanged = (item: number) => {
    this.props.updateInputSets([item])
  }

  subTreeChanged = (items: number[]) => {
    this.setState({ openSubItems: items })
  }

  getAccordionItems = (kase, touchedItems, validCategories, active) => {
    let items = [
      <Item
        title="Location"
        num={1}
        key={1}
        // customKey={11}
        touched={contains('location', touchedItems)}
        valid={contains('location', validCategories)}
        onTitleClick={() => this.props.selectItem('LOCATION')}
      >
        <ItemLine
          active={active === 'location'}
          onClick={() => this.props.selectItem('LOCATION')}
        >
          Location
        </ItemLine>
      </Item>
    ]

    if (showSpaceType()) {
      items.push(
        <Item
          title="Space type"
          num={2}
          key={2}
          // customKey={12}
          touched={contains('spacetype', touchedItems)}
          valid={contains('spacetype', validCategories)}
          onTitleClick={() => this.props.selectItem('SPACE_TYPE')}
        >
          <ItemLine
            active={active === 'spacetype'}
            onClick={() => this.props.selectItem('SPACE_TYPE')}
          >
            Type of space
          </ItemLine>
        </Item>
      )
    } else {
      // Very ugly hack, should find out why accordion for slabs won't stay open
      // if this is missing, even thought seem that we are not selecting by index
      items.push(<p style={{ display: 'none' }} />)
    }

    items.push(
      <Item
        onTitleClick={this.props.selectFirstBeam}
        title="Beam"
        num={3}
        key={3}
        // customKey={13}
        touched={contains('beams', touchedItems)}
        valid={contains('beams', validCategories)}
      >
        {kase.beams.map(beam => (
          <ItemLine
            key={beam.id}
            onClick={() => this.props.selectItem(beam.id)}
            active={beam.id === this.props.activeItem}
          >
            Current beam
          </ItemLine>
        ))}
      </Item>
    )

    items.push(
      <Item
        title="Slab"
        onTitleClick={this.props.selectFirstSlab}
        num={4}
        key={4}
        // customKey={14}
        touched={contains('slabs', touchedItems)}
        valid={contains('slabs', validCategories)}
      >
        {kase.slabs
          .filter(slab => !this.props.isDrBeam || !slab.disabled)
          .map(slab => (
            <ItemLine
              disabled={slab.disabled}
              key={slab.id}
              className="dbs-slab"
              onClick={() => {
                this.props.selectItem(slab.id)
                /* We may have already rendered a slab form here so autoFocus won't work. Let's just
                (imperatively) set the focus to first field */
                const el: Element | null = document.querySelector(
                  `.dbs-slab-type-select`
                )
                if (el) {
                  window.setTimeout(() => (el as HTMLElement).focus(), 0)
                }
              }}
              active={slab.id === this.props.activeItem}
            >
              {slab.name} {slab.disabled && '(disabled)'}
            </ItemLine>
          ))}
      </Item>
    )

    items.push(
      <Item
        title="Loads"
        onTitleClick={this.props.selectFirstLoadCase}
        num={5}
        key={5}
        // customKey={15}
        touched={contains('loads', touchedItems)}
        valid={contains('loads', validCategories)}
      >
        <InputLoads
          loads={kase.loadCases}
          onTreeChanged={this.subTreeChanged}
          openItems={this.state.openSubItems}
          selectItem={this.props.selectItem}
          activeItem={this.props.activeItem}
        />
      </Item>
    )
    return items
  }

  renderAccordion(kase: EditableCase) {
    const validCategories = this.props.validCategories
    const touchedItems = this.props.touchedCategories
    const active = this.props.activeCategory

    return (
      <Accordion
        key="accordion"
        onChange={this.treeChanged}
        activeItems={this.props.openInputSets}
      >
        {this.getAccordionItems(kase, touchedItems, validCategories, active)}
      </Accordion>
    )
  }

  render() {
    if (!this.props.case) {
      return null
    }
    return this.renderAccordion(this.props.case)
  }
}

const mapStateToProps = (state: Store.Complete) => ({
  case: getActiveCase(state),
  isDrBeam: getDrTypeBeam(state),
  location: getProjectLocation(state),
  validCategories: getValidCategories(state),
  activeCategory: getActiveCategory(state),
  activeItem: getSelectedItemId(state),
  openInputSets: getActiveInputSet(state),
  touchedCategories: getTouchedCategories(state)
})

const mapDispatchToProps = (dispatch: Dispatch<Store.Complete>) => ({
  selectItem: (itemId: string) => dispatch(selectCaseItem(itemId)),
  updateInputSets: (items: number[]) => dispatch(updateOpenInputSets(items)),
  selectFirstBeam: () => dispatch(selectFirstBeam()),
  selectFirstSlab: () => dispatch(selectFirstSlab()),
  selectFirstLoadCase: () => dispatch(selectFirstLoadCase())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InputCase)



// WEBPACK FOOTER //
// ./src/Components/Workspace/Calculation/InputCase.tsx